<app-register-component
  logoUrl='AiwynLogo.png'
></app-register-component>
